import { KeyValue } from '@angular/common';

export class ModalData {
  constructor(public title: string,
              public message: string,
              public translateParams: object,
              public link?: KeyValue<string, string>,
              public fragment?: string) {
  }
}

export class ValidationModalData extends ModalData {
  constructor(public title: string,
              public message: string,
              public translateParams: object,
              public validationErrors: ValidationError[] = null,
              public link?: KeyValue<string, string>) {
    super(title, message, translateParams, link);
  }
}

export class DetailsModalData extends ModalData {
  constructor(public title: string,
              public message: string,
              public translateParams: object,
              public details: string,
              public link?: KeyValue<string, string>,
              public fragment?: string) {
    super(title, message, translateParams, link, fragment);
  }
}

export class ValidationError {
  location: string;
  message: string;
  schema: string;
  test: string;
}
